export default "__VITE_ASSET__O15IEPku__"